import Signup from '@components/common/Footer/Signup/Signup'
import Section from '@components/common/Section/Section'
import SublimeMedia from '@components/common/SublimeMedia/SublimeMedia'
import clsx from 'clsx'
import { FC } from 'react'
import { MediaPicker } from 'types/mediaPicker'
import { ModuleProps } from '..'
import styles from './NewsletterSignup.module.scss'

export type NewsletterInputField = {
  contentTypeAlias: 'newsletterInputField'
  newsletterInputLabel: string
  placeholder: string
  sendgridMapping: string
  isHalf: boolean
  isRequired: boolean
  isTextArea: boolean
}

export type NewsletterCountrySelectorField = {
  contentTypeAlias: 'newsletterCountrySelector'
  newsletterCountryLabel: string
  sendgridMapping: string
}

export type NewsletterDropdownField = {
  contentTypeAlias: 'newsletterDropdownField'
  labelNewsletterDropdown: string
  dropdownItems: string[]
  sendgridMapping: string
}

export type NewsletterTextBlock = {
  contentTypeAlias: 'newsletterTextBlock'
  textBlock: string
}

export type NewsletterField =
  | NewsletterInputField
  | NewsletterCountrySelectorField
  | NewsletterTextBlock
  | NewsletterDropdownField

export type NewsletterSignupProps = {
  image: MediaPicker
  imagePlacement: 'Left' | 'Right' | 'Center'
  mobileImagePlacement: 'Top' | 'Bottom'
  signupText: string
  signUpForNewsletter: boolean
  newsletterConsentMessage: string
  emailPlaceholderLabel: string
  enableConsumerSignup: boolean
  enableProfessionalSignup: boolean
  enablePartnerSignup: boolean
  enablePressSignup: boolean
  consumerCheckboxLabel: string
  professionalCheckboxLabel: string
  partnerCheckboxLabel: string
  pressCheckboxLabel: string
  acceptTerms: string
  acceptTermsReadMore: string
  enableAcceptTermsCheckbox: boolean
  signupButtonLabel: string
  signupCompletedMessage: string
  fields: NewsletterField[]
} & ModuleProps
const NewsletterSignup: FC<NewsletterSignupProps> = ({
  image,
  imagePlacement,
  mobileImagePlacement,
  fields,
  ...args
}) => {
  return (
    <Section
      style={{
        position: 'relative',
      }}
      className={styles.outerContainer}
    >
      <div className={`${styles.container} `}>
        <div
          className={clsx(
            styles.innerContainer,
            mobileImagePlacement === 'Bottom' && styles.imageBottom,

            imagePlacement === 'Right' && styles.reversed
          )}
        >
          {imagePlacement !== 'Center' && (
            <div className={styles.shopTheLookContainer}>
              <div className={styles.shopTheLook}>
                <SublimeMedia mediaPicker={image} />
              </div>
            </div>
          )}

          <div className={styles.contentContainer}>
            <div className={styles.innerTextContent}>
              <div className="my-12 sm:my-36">
                <Signup fields={fields} {...args}></Signup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default NewsletterSignup
